import * as React from "react";
import { Spinner, Stack } from "@workflows/ui";
export function CoreSuspenseFallback(): JSX.Element {
  return <Stack fill justify="center" align="center" direction="vertical" className={"h-full"}>
      <Spinner />
    </Stack>;
}